import React, { Component } from "react";
import { trans } from "../../../helpers/index";
import Select from "react-select";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import AddOfficeStep2 from "./AddOfficeStep2";
import Modal from "../../Fragments/Modal";
import ErrorModal from "../../Fragments/ErrorModal";

class AddOffice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileFormResponse: "",
      buttonDisabled: false,

      fixinSuccessModal: false,
      fixinFormResponse: "",
      fixinButtonDisabled: false,
      showErrorModal: false,
    };

    this.componentIsMounted = true;

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.errorCallBack = this.errorCallBack.bind(this);
  }

  componentWillUnmount() {
    this.componentIsMounted = true;
  }

  componentDidMount() {
    if (this.props.parentState.addOffice.selectedOption === "") {
      let newState = this.props.parentState.addOffice;

      newState["selectedOption"] = this.options()[0];

      this.props.updateParentState(newState);
    }
  }

  options() {
    return [
      { value: 1, label: trans(this.props.trans, "add.office.option1") },
      { value: 2, label: trans(this.props.trans, "add.office.option2") },
    ];
  }

  handleSelectChange(selectState) {
    let newState = this.props.parentState.addOffice;

    newState["selectedOption"] = selectState;

    this.props.updateParentState(newState);
  }

  mobileRequest() {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        msisdn: this.props.parentState.addOffice.msisdn,
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
      },
      "/account/mob/request"
    ).then((resolve) => {
      if (!this.componentIsMounted) {
        return;
      }

      this.setState({
        buttonDisabled: false,
        mobileFormResponse: resolve.data,
      });

      if (resolve.data.status === "OK") {
        let newState = this.props.parentState.addOffice;

        newState["mobileToken"] = resolve.data.token;
        newState["mobileStep"] = 2;
        newState["mobileTimeLife"] =
          this.props.config.data.mob_code_lifetime * 60;

        this.props.updateParentState(newState);

        this.props.lifeTimeCounter();
      }
    }, this.errorCallBack);
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  sendData(event) {
    event.preventDefault();

    // Mobile request
    if (this.props.parentState.addOffice.selectedOption.value === 1) {
      this.mobileRequest();
    } else if (this.props.parentState.addOffice.selectedOption.value === 2) {
      this.setState({ fixinButtonDisabled: true });

      ApiManager.postRequest(
        {
          login: this.props.parentState.addOffice.fixinName,
          ban_id: this.props.parentState.addOffice.fixinId,
          jwt: this.props.getDecryptedToken(),
          _token: this.props.csrf_token.data,
        },
        "/account/fixin/request"
      ).then((resolve) => {
        this.setState({
          fixinButtonDisabled: false,
          fixinFormResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          this.setState({ fixinSuccessModal: true });
        }
      }, this.errorCallBack);
    }
  }

  mobileStep() {
    let msisdnErrorClass = "",
      msisdnErrorBox = "",
      errorBox = "";

    if (this.state.mobileFormResponse !== "") {
      if (this.state.mobileFormResponse.status === "INVALID_DATA") {
        if (this.state.mobileFormResponse.errors.hasOwnProperty("msisdn")) {
          msisdnErrorClass = " form-error";
          msisdnErrorBox = (
            <div className="form-error-text fs11">
              {this.state.mobileFormResponse.errors.msisdn}
            </div>
          );
        }
      }

      if (this.state.mobileFormResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={this.state.mobileFormResponse.message}
          />
        );
      }
    }

    return (
      <>
        <div className={`form__form-box${msisdnErrorClass}`}>
          <label className="form__label db fs11" htmlFor="tel-number">
            {trans(this.props.trans, "add.office.number_label")}
          </label>
          <div className="form__field-out form__field-out--with-prefix pr">
            <input
              className="form__field fs13"
              id="tel-number"
              name="tel-number"
              type="text"
              value={this.props.parentState.addOffice.msisdn}
              onChange={(event) => {
                let newState = this.props.parentState.addOffice;
                newState["msisdn"] = event.target.value
                  .trim()
                  .replace(/[^\d]/g, "");

                this.props.updateParentState(newState);
              }}
            />
            <div className="form__info-box pa">
              <button className="form__info sprite" type="button">
                {" "}
              </button>
              <div className="form__info-txt fs11 pa">
                {trans(this.props.trans, "add.office.number_note")}
              </div>
            </div>
          </div>
          {msisdnErrorBox}
        </div>
        {errorBox}
        <button
          className={`form__submit-btn btn btn--yellow fs17${
            this.state.buttonDisabled ? " btn--loading" : ""
          }`}
          type="submit"
          disabled={this.state.buttonDisabled}
        >
          {trans(this.props.trans, "add.office.button_title")}
        </button>
      </>
    );
  }

  successModal() {
    if (!this.state.fixinSuccessModal) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "add.office.fixin_success.title")}
        description={trans(
          this.props.trans,
          "add.office.fixin_success.description"
        )}
        agreeText={trans(this.props.trans, "add.office.fixin_success.agree")}
        agreeAction={() =>
          this.setState({
            fixinSuccessModal: false,
            fixinName: "",
            fixinId: "",
          })
        }
        className="modal--full"
      />
    );
  }

  fixinStep() {
    let nameErrorClass = "",
      nameErrorBox = "",
      banIdErrorClass = "",
      banIdErrorBox = "",
      errorBox = "";

    if (this.state.fixinFormResponse !== "") {
      if (this.state.fixinFormResponse.status === "INVALID_DATA") {
        if (this.state.fixinFormResponse.errors.hasOwnProperty("login")) {
          nameErrorClass = " form-error";
          nameErrorBox = (
            <div className="form-error-text fs11">
              {this.state.fixinFormResponse.errors.login}
            </div>
          );
        }

        if (this.state.fixinFormResponse.errors.hasOwnProperty("ban_id")) {
          banIdErrorClass = " form-error";
          banIdErrorBox = (
            <div className="form-error-text fs11">
              {this.state.fixinFormResponse.errors.ban_id}
            </div>
          );
        }
      }

      if (this.state.fixinFormResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError message={this.state.fixinFormResponse.message} />
        );
      }
    }

    return (
      <>
        <div
          className={`form__form-box form__form-box--with-space${nameErrorClass}`}
        >
          <label className="form__label db fs11" htmlFor="name">
            {trans(this.props.trans, "add.office.name_label")}
          </label>
          <div className="form__field-out pr">
            <input
              className="form__field fs13"
              id="name"
              type="text"
              name="name"
              value={this.props.parentState.addOffice.fixinName}
              onChange={(event) => {
                let newState = this.props.parentState.addOffice;
                newState["fixinName"] = event.target.value
                  .trim()
                  .replace(/[^\d]/g, "");

                this.props.updateParentState(newState);
              }}
            />
          </div>
          {nameErrorBox}
        </div>
        <div
          className={`form__form-box form__form-box--with-space${banIdErrorClass}`}
        >
          <label className="form__label db fs11" htmlFor="id">
            {trans(this.props.trans, "add.office.id_label")}
          </label>
          <div className="form__field-out pr">
            <input
              className="form__field fs13"
              id="id"
              type="text"
              name="id"
              value={this.props.parentState.addOffice.fixinId}
              onChange={(event) => {
                let newState = this.props.parentState.addOffice;
                newState["fixinId"] = event.target.value
                  .trim()
                  .replace(/[^\d]/g, "");

                this.props.updateParentState(newState);
              }}
            />
          </div>
          {banIdErrorBox}
        </div>
        {errorBox}
        <button
          className={`form__submit-btn btn btn--yellow fs17${
            this.state.fixinButtonDisabled ? " btn--loading" : ""
          }`}
          type="submit"
          disabled={this.state.fixinButtonDisabled}
        >
          {trans(this.props.trans, "add.office.button_fixin_title")}
        </button>
      </>
    );
  }

  stepSwitcher() {
    if (this.props.parentState.addOffice.selectedOption.value === 1) {
      return this.mobileStep();
    }

    return this.fixinStep();
  }

  initSteps() {
    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--add monserrat-medium pr sprite-b">
          {trans(this.props.trans, "add.office.main_title")}
        </h2>

        <div className="form form--p24 form--bottom-radius">
          <form
            action="#"
            method="post"
            onSubmit={(event) => this.sendData(event)}
          >
            <div className="form__form-box form__form-box--with-space">
              <div className="form__field-out form__field-out--select-big pr">
                <Select
                  options={this.options()}
                  value={this.props.parentState.addOffice.selectedOption}
                  onChange={this.handleSelectChange}
                  placeholder={trans(
                    this.props.trans,
                    "add.office.select_default_label"
                  )}
                  noOptionsMessage={() =>
                    trans(
                      this.props.trans,
                      "add.office.select_no_options_message"
                    )
                  }
                />
              </div>
            </div>

            {this.stepSwitcher()}
            {this.successModal()}
          </form>
        </div>
      </section>
    );
  }

  tabFlow() {
    let result = null;

    switch (true) {
      case this.props.parentState.addOffice.mobileStep === 2:
        result = (
          <AddOfficeStep2
            trans={this.props.trans}
            csrf_token={this.props.csrf_token}
            config={this.props.config}
            mobileConfig={this.props.parentState.addOffice}
            refreshAccountList={this.props.refreshAccountList}
            updateParentState={this.props.updateParentState}
            getDecryptedToken={this.props.getDecryptedToken}
            lifeTimeCounter={this.props.lifeTimeCounter}
            clearAddOfficeTimer={this.props.clearAddOfficeTimer}
          />
        );
        break;
      default:
        result = this.initSteps();
    }

    return result;
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    return (
      <div className="main-wrapper__double-list main-wrapper__double-list--max-976">
        <div className="main-wrapper__double-list-item ver-top-box">
          {this.tabFlow()}
        </div>
        {this.errorModal()}
      </div>
    );
  }
}

export default AddOffice;
